/* eslint-disable */
import React from 'react';
import styled, { css } from 'react-emotion';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';
import { Box, Flex } from '../Layout';
import feather from '../../utils/feather';
import media from '../../utils/media';
import Img from "gatsby-image"
import cclogo from "../../assets/images/cc.png"

const footerStyle = css`
  overflow: hidden;
  text-align: center;

  & img {
    display: block;
    margin: 0;
  }
  & p {
    color: rgba(255, 255, 255, 0.5);
  }
`;

const ulStyle = css`
  list-style-type: none;
  margin: 0;
  margin-bottom: 1.45rem;
  text-transform: uppercase;
  padding: 0;
  & a {
    cursor: pointer;
    opacity: 0.5;
    transition: opacity 0.15s ease-in;
    transition: color 0.15s ease-in;

    &:hover {
      text-decoration: none;
      box-shadow: none;
      opacity: 1;
      transition: opacity 0.15s ease-in;
    }
  }
  & li {
    margin: 0;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  margin: 0;
  & p {
    margin: 0;
    margin-bottom: 1.45rem;
  }
`;

const socialList = css`
  display: flex;
  justify-content: space-between;
  list-style-type: none;
  margin: 0;
  padding: 0;

  ${media.large`
    width: 50%;
    margin-left: auto;
  `};
`;

const svgStyles = css`
  opacity: 0.5;
  transition: opacity 0.15s ease-in;
  transition: color 0.15s ease-in;

  &:hover {
    text-decoration: none;
    box-shadow: none;
    opacity: 1;
    transition: opacity 0.15s ease-in;
  }
`;

const Footer = props => (
  <div className={footerStyle}>
    <Box p={[3, 3, 4]} align="left" color="black">
      <Flex wrap={['wrap', 'wrap', 'nowrap']} justify="space-between">
        <Box width={[1, 1, 1 / 5]}>
          <Wrapper>
            <ul className={ulStyle}>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <a href="https://community.chi.camp/">
                  CHIC Community Page
                </a>
              </li>
              <li>
                <a href="https://chi.camp/blog//">
                  CHIC Blog
                </a>
              </li>
            </ul>
          </Wrapper>
        </Box>
        <Box width={[1, 1, 2 / 5]}>
          <Wrapper>
            <div>
            <a rel="license" href="http://creativecommons.org/licenses/by-nc-sa/4.0/">
            <img alt="Creative Commons Licence" src={cclogo} /></a>
            <br />The works on this site are licensed under a <a rel="license" href="http://creativecommons.org/licenses/by-nc-sa/4.0/">Creative Commons Attribution-NonCommercial-ShareAlike 4.0 International License</a>.
            <br/>
            </div>
            <div>    
            <br/>
              Beta test phase ongoing. Content will change regularly!
            <br/>
            </div>
          </Wrapper>
        </Box>
        <Box width={[1, 1, 2 / 5]}>
          <Wrapper>
            <ul className={socialList}>
              <li>
                <a
                  title="Link to our Facebook page"
                  href={props.facebook}
                  rel="noopener"
                >
                  {feather('facebook', ['30', '30'], svgStyles)}
                </a>
              </li>
              <li>
                <a
                  title="Link to our Twitter account"
                  href={props.twitter}
                  rel="noopener"
                >
                  {feather('twitter', ['30', '30'], svgStyles)}
                </a>
              </li>
              <li>
                <a
                  title="Link to out Instragram account"
                  href={props.instagram}
                  rel="noopener"
                >
                  {feather('instagram', ['30', '30'], svgStyles)}
                </a>
              </li>
              <li>
                <a title="Our E-Mail address" href={`mailto:${props.email}`}>
                  {feather('mail', ['30', '30'], svgStyles)}
                </a>
              </li>
            </ul>
          </Wrapper>
        </Box>
      </Flex>
    </Box>
    <Box px={[3, 3, 1]} align="center">
      <p>{`Copyright © 2018. Some rights reserved.`}</p>
    </Box>
  </div>
);

Footer.propTypes = {
  name: PropTypes.string,
  facebook: PropTypes.string,
  twitter: PropTypes.string,
  instagram: PropTypes.string,
  email: PropTypes.string
};

Footer.defaultProps = {
  facebook: 'https://www.facebook.com/ChinaHardwareInnovationCamp/',
  twitter: 'https://twitter.com/chic_community',
  instagram: 'https://www.instagram.com/chi.camp/',
  email: 'info@chi.camp'
};


export default { Footer };



// WEBPACK FOOTER //
// ./src/components/Footer/index.js